import React from 'react';
import { createPortal } from 'react-dom';

export function Field({ label, required, children, hint }) {
  return (
    <label className="block">
      <div className="text-[11px] uppercase tracking-[0.18em] text-ink-muted font-semibold mb-1.5">
        {label}{required && <span className="text-terracotta-700"> *</span>}
      </div>
      {children}
      {hint && <div className="text-xs text-ink-muted mt-1">{hint}</div>}
    </label>
  );
}

export const inputCls = 'w-full px-3 py-2 rounded-lg border border-stone_line focus:outline-none focus:border-sage';
export const monoCls = `${inputCls} font-mono text-sm`;
export const selectCls = `${inputCls} bg-white`;

export function Modal({ onCancel, children, wide }) {
  // Rendered via portal to <body> so the overlay anchors to the viewport,
  // not to any ancestor that creates a containing block (e.g. AdminPage's
  // `animate-fade-up` ends with `transform: matrix(...)` — even an identity
  // transform on an ancestor makes `position: fixed inset-0` resolve
  // against that ancestor instead of the viewport).
  //
  // The modal is anchored from the top so its upper line always sits just
  // a few pixels below the sticky top bar (~64px tall). Internal scroll
  // handles tall content.
  return createPortal(
    <div
      className="fixed inset-0 z-50 flex justify-center items-start bg-ink/40 backdrop-blur-sm px-4 pb-4 pt-[72px]"
      onClick={onCancel}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`bg-white rounded-2xl shadow-soft-lg border border-stone_line ${wide ? 'max-w-2xl' : 'max-w-lg'} w-full p-6 space-y-4 max-h-[calc(100vh-88px)] overflow-y-auto animate-fade-up`}
      >
        {children}
      </div>
    </div>,
    document.body,
  );
}
